export const HOME = {
  heroHeadline: 'home-hero-headline',
  heroCtaConsult: 'home-hero-cta-consultation-button',
  heroCtaExplore: 'home-hero-cta-explore-button',
  heroCtaWhatsapp: 'home-hero-cta-whatsapp-button',
  statsContainer: 'home-stats-container',
  expertiseSelenium: 'home-expertise-card-selenium',
  expertisePlaywright: 'home-expertise-card-playwright',
  expertiseAppium: 'home-expertise-card-appium',
  expertiseReadMore: 'home-expertise-read-more',
  booksGrid: 'home-books-grid',
  videoTestimonialsCarousel: 'home-video-testimonials-carousel',
  newsletterInput: 'home-newsletter-email-input',
  newsletterSubmit: 'home-newsletter-submit-button',
};
